import { SIGNUP_FAILURE, SIGNUP_SUCCESS, USER_DETAILS_FAILURE, USER_DETAILS_SUCCESS, USERLIST_FAILURE, USERLIST_SUCCESS } from "./auth.actionTypes";

const initialState = {
  signupData: null,
  userDetails: null,
  message: null
};

export default function AuthReducer(state = initialState, { type, payload }) {
  switch (type) {
    case SIGNUP_SUCCESS:
      return {
        ...state,
        signupData: payload.data,
      };
    case SIGNUP_FAILURE:
      return {
        ...state,
        message: payload.message,
      };

         case USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: payload,
      };
    case USER_DETAILS_FAILURE:
      return {
        ...state,
        message: "",
      };

    default:
      return state;
  }
}
